module.exports = {"data":{"site":{"siteMetadata":{"title":"Walsh Painting Contractors","description":"Master painters and decorators. Walsh Painting Contractors operate near Byron Bay, Northern NSW and specialise in luxury homes and specialised projects.","image":"/wpc-logo-small.png","siteUrl":"https://walshpainting.com.au"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 119
// module chunks = 60335399758886 114276838955818